import { render, staticRenderFns } from "./UserAssignment.vue?vue&type=template&id=b4200cec"
import script from "./UserAssignment.vue?vue&type=script&lang=js"
export * from "./UserAssignment.vue?vue&type=script&lang=js"
import style0 from "./UserAssignment.vue?vue&type=style&index=0&id=b4200cec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports